import { render, staticRenderFns } from "./DataTangHuaXueHongDanBai.vue?vue&type=template&id=73a09230&"
import script from "./DataTangHuaXueHongDanBai.vue?vue&type=script&lang=js&"
export * from "./DataTangHuaXueHongDanBai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports